<template>
 <div class="row products-select">
    <div class="col">
        <div class="row">
          <div class="col d-flex operation-table-actions align-items-center justify-content-start">
            <router-link v-if="isAddAgent" class="btn btn-back btn-lg" to="/ad-agent/calculate" tag="button">
                <i class="fa fa-angle-left px-1"></i>
            </router-link>
            <router-link v-else class="btn btn-back btn-lg" to="/calculate" tag="button">
                <i class="fa fa-angle-left px-1"></i>
            </router-link>
            <h2 class="ml-4">{{printMachine ? printMachine.name : ''}} / Выбор продукта</h2>
          </div>
        </div>
        <div class="row mt-4">
            <div class="col-6">
              <div class="input-group with-clear-icon">
                <input type="text" class="form-control" v-model="searchText">
                <i class="ico ico-close" @click="clearSearchText" v-if="searchText.length > 0"></i>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-search"></i>
                  </span>
                </div>
              </div>
            </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <button class="btn btn-primary mt-2 mr-4" v-for="product in filterdProducts" :key="product.id" :title="product.name" @click="selectProduct(product.id)">
              {{product.name}}
            </button>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import api from '../../../api'
import roles from '../../../helpers/userRoles'
export default {
  name: 'CalculateProductSelect',
  components: {},
  props: {
    printMachineId: {
      default: null
    }
  },
  data: () => {
    return {
      products: [],
      searchText: '',
      printMachine: null
    }
  },
  methods: {
    selectProduct (productId) {
      if (this.isAddAgent) {
        this.$router.push(`/ad-agent/calculate/price/${this.printMachineId}/${productId}`)
      } else {
        this.$router.push(`/calculate/price/${this.printMachineId}/${productId}`)
      }
    },
    clearSearchText () {
      this.searchText = ''
    }
  },
  computed: {
    filterdProducts () {
      let result = this.products
      if (this.searchText) {
        result = result.filter(
          x => x.name.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0
        )
      }

      result = result.filter(x => x.enabled)

      result = result.sort((prev, next) => {
        const x = prev.name.toLowerCase()
        const y = next.name.toLowerCase()
        if (x < y) { return -1 }
        if (x > y) { return 1 }
        return 0
      })

      return result
    },
    isAddAgent () {
      return this.$store.getters.role === roles.adAgent
    }
  },
  created () {
    api.get.printMachineProducts(this.printMachineId).then(resp => {
      this.products = resp.data.data.products
    })

    api.get.printMachine(this.printMachineId).then(resp => {
      this.printMachine = resp.data.data.printMachine
    })
  }
}
</script>

<style lang="scss" scoped>
.products-select {
  .btn-primary {
    width: 300px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
</style>
